import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { useSelector } from 'react-redux';
import formatNumberWithAbbreviation from '../../utils/numberMeasurementFormat';

const EpHighlightIndicator = ({
  value, valueSymbol, valueDigits, description, iconPath, iconAlt, currentUserLanguage,
}) => {
  const isAuthorizedUser = useSelector(state => state.auth.isAuthorizedUser);
  const [valueSymbolFormatted, setValueSymbolFormatted] = useState(valueSymbol);
  const [formattedValue, setFormattedValue] = useState(
    formatNumberWithAbbreviation(value, valueDigits, currentUserLanguage),
  );

  useEffect(() => {
    if (value === null) {
      setValueSymbolFormatted('');
    }

    setFormattedValue(formatNumberWithAbbreviation(value, valueDigits, currentUserLanguage));
  }, [currentUserLanguage, isAuthorizedUser]);

  return (
    <div className="highlight-indicator" data-testid="highlight-indicator">
      <img className="highlight-indicator__icon" data-testid="highlight-indicator__icon" alt={iconAlt} src={iconPath} />
      <span className="highlight-indicator__value" data-testid="highlight-indicator__value">{valueSymbolFormatted}{formattedValue}</span>
      <span className="highlight-indicator__name" data-testid="highlight-indicator__name">{description}</span>
    </div>
  );
};

export default EpHighlightIndicator;

EpHighlightIndicator.defaultProps = {
  value: null,
  valueSymbol: '',
};

EpHighlightIndicator.propTypes = {
  value: PropTypes.number,
  valueSymbol: PropTypes.string,
  valueDigits: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  iconPath: PropTypes.string.isRequired,
  iconAlt: PropTypes.string.isRequired,
  currentUserLanguage: PropTypes.string.isRequired,
};
